export default "__VITE_ASSET__B7QN0PiG__"